<template>
  <div class="select-custom-text">
    <div class="select-custom-text__select">
      <m4-select
        ref="main_select"
        :name="name"
        :options="options"
        :value="newValue"
        @change="changeValue"
        v-bind="$attrs"
        :error="error"
      ></m4-select>
    </div>
    <m4-form-field
      v-if="showTextField"
      :type="customFieldType"
      :name="getTextFieldName"
      :label-above="customFieldLabelAbove"
      :placeholder="customFieldPlaceholder"
      :value="customFieldValue"
      :error="customFieldError"
      @update:modelValue="(val) => $emit('customFieldInput', val)"
    ></m4-form-field>
  </div>
</template>

<script>
import valueProp from "../../../utils/valueProp.js";

export default {
  name: "M4SelectCustomText",
  mixins: [valueProp],
  data() {
    return {
      newValue: this.modelValue ? this.modelValue : this.value
    };
  },
  props: {
    error: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: [String]
    },
    name: String,
    customFieldType: {
      type: String,
      default: "text"
    },
    customFieldLabelAbove: {
      type: String,
      default: ""
    },
    customFieldPlaceholder: {
      type: String,
      default: ""
    },
    customFieldName: {
      type: String
    },
    customFieldValue: {
      type: String,
      default: ""
    },
    customFieldError: {
      type: String
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  emits: ["customFieldInput", "selectboxChange"],
  computed: {
    getTextFieldName() {
      let name = this.name + "__text";
      if (this.customFieldName) {
        name = this.customFieldName;
      }
      return name;
    },
    showTextField() {
      return typeof this.options.find((option) => option.textfield && option.value == this.newValue) == "object";
    }
  },
  methods: {
    setNewValue(value) {
      this.newValue = value;
      this.$refs.main_select.setSelected(this.newValue);
    },
    changeValue(e) {
      this.newValue = e.target.value;
      this.$emit("selectboxChange", this.newValue);
    }
  }
};
</script>
